import './public-path';
import React from 'react';
import { hydrateRoot } from "react-dom";
import App from './App';
import { Provider } from 'react-redux';
import {persistor, store} from './store';
import { PersistGate } from 'redux-persist/integration/react';

console.log('__webpack_public_path__ ----', __webpack_public_path__);

hydrateRoot(
  document.getElementById('app'),
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
);
